import axios from "axios";
import I18n from "i18n-js";
import isEmpty from "lodash/isEmpty";
export * from "./FeatureHelper";
export * from "./HelpCenter";
import {
  userGuideEnglishVersion,
  userGuideMalayVersion,
  userGuideThaiVersion,
  userGuideVietnameseVersion,
  userGuideBahasaVersion,
  ADMIN_KEY,
  PROFILE_KEY,
  FINANCES_KEY,
  INSIGHTS_KEY,
  MENU_KEY,
  INVENTORY_KEY,
  MARKETING_KEY,
  TROY_LOCAL_HOSTNAME,
  TROY_STAGE_HOSTNAME,
  TROY_PHOENIX_STAGE_HOSTNAME,
  VN_STAGE_HOSTNAME,
  ID_STAGE_HOSTNAME,
  GP_STAGE_HOSTNAME,
  PAYNOW_KEY,
  HOME_KEY,
  ORDER_KEY,
  FEEDBACK_KEY,
  ID,
  MY,
  PH,
  SG,
  TH,
  VN,
  MM,
  ROLE_CASHIER,
  MULTI_ENTITY_PLATFORM,
  UNVERIFIED_MERCHANT_PLATFORM,
  ovo,
  moca,
  GP,
  BUSINESS_LINE_IDS_LS,
  PROD_WEB_TO_APP_URL,
  STG_WEB_TO_APP_URL,
  KH,
  GM,
  GF,
  ROLE_AUTHZ,
  ROLE_SUPER_ADMIN,
  EMPLOYEE_MANAGEMENT,
  mexHasMmOrder,
  mexHasImOrder,
  enableMFE,
  enableMexPortalObserverMode,
  enableMarketingForObserver,
} from "../constants";
import get from "lodash/get";
import { isAllowedToCreate } from "./PermissionHelper";
import {
  haveAccessToFeature,
  getMexApiMigrations,
  isWebloginFeatureEnabled,
} from "./FeatureHelper";
import {
  hasPermission,
  PERMISSION_ACTION,
  getModuleNameByKey,
  getConfigByKey,
  isUserPermissionSystemActive,
  isSelectedMerchantVE,
  getResourceKeys,
} from "@mex/mex-permissions-lib";

const grabpay = "grabpay";
const grabfood = "grabfood";
const grabads = "grabads";

export const HELP_CENTER_URL_STAGING = "https://help.stg-myteksi.com";
export const HELP_CENTER_URL_PRODUCTION = "https://help.grab.com";

const HELP_CENTER_AUTH_HANDOVER_PATH = "/auth_handover";
const MEX_HELP_CENTER_PATHS = {
  SGD: "/merchant/en-sg/",
  PHP: "/merchant/en-ph/",
  MYR: "/merchant/en-my/",
  IDR: "/merchant/id-id/360001717951-Panduan-terkait-aplikasi-GrabMerchant-dan-Portal",
  VND: "/merchant/vi-vn/",
  THB: "/merchant/th-th/",
  KHR: "/merchant/km-kh/",
  MMK: "/merchant/my-mm/",
  DEFAULT: "/merchant",
};

export const profilePage = "/profile";
export const profileLogout = "/profile/logout";
export const admin = "/userprofile/admin";
export const GFRedirect = "/food/merchant";
export const GFMenu = "/food/menu";
export const ADSUMP = "/marketing";
export const GFInventory = "/food/inventory";
export const finances = "/finances";
export const insights = "/insights";
export const marketing = "/marketing";
export const payNow = "/paynow";
export const home = "/dashboard";
export const order = "/order";
export const feedback = "/feedback";
export const observer = "/observer";
export const crm = "/crm";

export const MasterMerchantUserTypes = [9, 10, 11, 12, 13];

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4() + s4()}${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}`;
}

export const apiCaller = (timeout = 5000) => {
  const isWebloginEnabled = isWebloginFeatureEnabled();
  const authHeader = isWebloginEnabled
    ? {}
    : {
        "x-mts-ssid": localStorage.getItem("JWT"),
      };
  let resourceHeader = {};
  if (isUserPermissionSystemActive() || isSelectedMerchantVE()) {
    resourceHeader = {
      "x-mex-resource": getResourceKeys(),
      "x-mex-version": "v2",
    };
  }
  return axios.create({
    baseURL: window.location.origin,
    timeout,
    headers: {
      "Content-Type": "application/json",
      ...authHeader,
      ...resourceHeader,
      "x-request-id": guid(),
      "x-agent": "mexapp",
      "x-app-version": "1.0.0",
      "x-app-platform": "web",
      "x-device-id": "ios",
      "X-User-Type": localStorage.getItem("USER_PROFILE") || null,
    },
  });
};

export const countryWithLabel = {
  GB: I18n.t("troyCommon-langselect-menu-01"),
  ID: I18n.t("troyCommon-langselect-menu-02") || "Indonesia",
};

export const getCountry = (lang) => {
  if (lang.toLowerCase().indexOf("id") !== -1) {
    return "ID";
  }
  if (lang.toLowerCase().indexOf("vn") !== -1) {
    return "VN";
  }
  if (lang.toLowerCase().indexOf("my") !== -1) {
    return "MY";
  }
  if (lang.toLowerCase().indexOf("th") !== -1) {
    return "TH";
  }
  return "GB";
};

export function GET_COUNTRY_WITH_CURRENCY() {
  if (localStorage.getItem("currency")) {
    if (localStorage.getItem("currency").toLowerCase() === "idr") {
      return ID;
    }
    if (localStorage.getItem("currency").toLowerCase() === "myr") {
      return MY;
    }
    if (localStorage.getItem("currency").toLowerCase() === "php") {
      return PH;
    }
    if (localStorage.getItem("currency").toLowerCase() === "sgd") {
      return SG;
    }
    if (localStorage.getItem("currency").toLowerCase() === "vnd") {
      return VN;
    }
    if (localStorage.getItem("currency").toLowerCase() === "thb") {
      return TH;
    }
    if (localStorage.getItem("currency").toLowerCase() === "mmk") {
      return MM;
    }
    if (localStorage.getItem("currency").toLowerCase() === "khr") {
      return KH;
    }
  }
}

export const getDefaultLanguage = () => {
  if (
    localStorage.getItem("lang") &&
    localStorage.getItem("lang") != "undefined"
  ) {
    return localStorage.getItem("lang");
  } else if (navigator.language) {
    return getCountry(navigator.language);
  } else if (
    get(
      JSON.parse(localStorage.getItem("userprofileInfo")),
      "user_profile.parent_entity_country",
    )
  ) {
    return getCountry(
      get(
        JSON.parse(localStorage.getItem("userprofileInfo")),
        "user_profile.parent_entity_country",
      ),
    );
  }
  return "GB";
};

export const changeLanguage = (lang, updateLanguage = null) => {
  const isMigratedApi = getMexApiMigrations("SetMexLanguage");
  const prefix = isMigratedApi ? "mex-core-api/" : "troy/";

  apiCaller()
    .post(`${prefix}v1/lang-config`, {
      language: lang,
      currency: localStorage.getItem("currency"),
    })
    .then((res) => {
      localStorage.setItem("lang", lang);
      if (updateLanguage != null) {
        updateLanguage(lang);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const isLoggedIn = function () {
  const isWebloginEnabled = isWebloginFeatureEnabled();
  const userProfile = GET_USERPROFILE_FROM_LS();
  return isWebloginEnabled
    ? !!userProfile
    : localStorage.getItem("JWT") != null;
};

export const allowAccess = () => {
  if (localStorage.userprofileInfo === undefined) {
    return false;
  }
  try {
    const allowRoles = [
      "admin",
      "owner",
      "store manager",
      "multi entity admin",
      "entity all access",
      ROLE_AUTHZ,
      ROLE_SUPER_ADMIN,
    ];
    const role = get(
      JSON.parse(localStorage.getItem("userprofileInfo")),
      "user_profile.role",
    );
    if (allowRoles.indexOf(role.toLowerCase()) > -1) {
      return true;
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const isAdmin = () => {
  if (localStorage.userprofileInfo === undefined) {
    return false;
  }
  try {
    const role = get(
      JSON.parse(localStorage.getItem("userprofileInfo")),
      "user_profile.role",
    );
    return role.toLowerCase() === "admin";
  } catch (err) {
    console.log(err);
    return false;
  }
};

function getHelpCenterBaseUrl() {
  const isNotProd = isStaging() || isLocal();
  return isNotProd ? HELP_CENTER_URL_STAGING : HELP_CENTER_URL_PRODUCTION;
}

export function getMexHelpCenterUrl() {
  const currency = localStorage.getItem("currency");
  const helpCenterPath =
    MEX_HELP_CENTER_PATHS[currency] || MEX_HELP_CENTER_PATHS["DEFAULT"];
  return getHelpCenterBaseUrl() + helpCenterPath;
}

export function getHelpCenterAuthUrl() {
  const baseUrl = getHelpCenterBaseUrl();
  const source = isLocal() ? "MEX_PORTAL_LOCAL" : "MEX_PORTAL";
  return `${baseUrl}${HELP_CENTER_AUTH_HANDOVER_PATH}?source=${source}`;
}

export const getDownloadAppOneLink = () => {
  const isNotProd = isStaging() || isLocal();
  return isNotProd ? STG_WEB_TO_APP_URL : PROD_WEB_TO_APP_URL;
};

export function getUserCountry() {
  try {
    return get(JSON.parse(localStorage.getItem("userprofileInfo")), "country");
  } catch (err) {
    return false;
  }
}

// setAvailableLanguage - Function for setting available language in Sidebar
export function setAvailableLanguage() {
  const country = getUserCountry() || getDefaultLanguage();
  switch (country.toUpperCase()) {
    case "SG":
      return ["GB", "CN"];
    case "MY":
      return ["GB", "MY"];
    case "ID":
      return ["GB", "ID"];
    case "TH":
      return ["GB", "TH"];
    case "VN":
      return ["GB", "VN"];
    case "PH":
      return ["GB"];
    case "KH":
      return ["GB"];
    default:
      return ["GB"];
  }
}

export function directToURl(history, ToUrl, params = "") {
  const urlMapper = {
    // grabpay
    [insights]: grabpay,
    [marketing]: grabpay,
    [home]: grabpay,
    [finances]: grabpay,
    [admin]: grabpay,
    [profilePage]: grabpay,
    [profileLogout]: grabpay,
    // grabfood
    [GFRedirect]: grabfood,
    [GFMenu]: grabfood,
    [GFInventory]: grabfood,
    [order]: grabfood,
    [feedback]: grabfood,
    [ADSUMP]: grabads,
  };

  const FromUrl = window.location.pathname;

  // disabled in local development
  // TODO remove condition
  if (window.__MFE_MODE) {
    // grabads is not in scope for the first phase
    if (
      !history ||
      urlMapper[FromUrl] === grabads ||
      urlMapper[ToUrl] === grabads
    ) {
      window.location.href = ToUrl + params;
      return;
    }
    if (haveAccessToFeature(enableMFE)) {
      history.push(ToUrl + params);
      return;
    }
    window.location.href = ToUrl + params;
  } else {
    if (urlMapper[FromUrl] === urlMapper[ToUrl] && history) {
      history.push(ToUrl + params);
    } else {
      window.location.href = ToUrl + params;
    }
  }
}

export function GET_USERPROFILE_FROM_LS() {
  try {
    return JSON.parse(localStorage.getItem("userprofileInfo"));
  } catch (err) {
    return null;
  }
}

export function isMasterMerchant() {
  const userProfile = GET_USERPROFILE_FROM_LS();
  const userType = get(userProfile, "user_type");
  return MasterMerchantUserTypes.includes(userType);
}

export function isRoleCashier() {
  return getUserRole() === ROLE_CASHIER;
}

export function hideOrderPage() {
  const businessLineIds = getBusinessLineIdsFromLocalStorage();
  return !businessLineIds.includes(GF) && !businessLineIds.includes(GM);
}

export function hideMarketingPage() {
  const userCountry = getUserCountry();
  return [MM, KH].includes(userCountry);
}

export function allowEmployeeManagementPage() {
  return isAllowedToCreate(EMPLOYEE_MANAGEMENT);
}

export function getUserRole() {
  return get(GET_USERPROFILE_FROM_LS(), ["user_profile", "role"]);
}

export function getUserProfileStatus() {
  return get(GET_USERPROFILE_FROM_LS(), ["user_profile", "profile_status"]);
}

export function getUserGuideFile() {
  const country = getUserCountry() || getDefaultLanguage();
  switch (country.toUpperCase()) {
    case "MY":
      return userGuideMalayVersion;
    case "TH":
      return userGuideThaiVersion;
    case "VN":
      return userGuideVietnameseVersion;
    case "ID":
      return userGuideBahasaVersion;
    default:
      return userGuideEnglishVersion;
  }
}

export const getSelectedMenu = () => {
  const pathName = location.pathname;
  if (pathName === "/") {
    if (hideDashboardPage() && hideInsightPage()) {
      return FINANCES_KEY;
    }
    if (hideDashboardPage()) {
      return INSIGHTS_KEY;
    }
    return HOME_KEY;
  }

  switch (pathName) {
    case "/insights":
      return INSIGHTS_KEY;
    case "/finances":
      return FINANCES_KEY;
    case "/food/menu":
      return MENU_KEY;
    case "/ump":
      return MARKETING_KEY;
    case "/food/inventory":
      return INVENTORY_KEY;
    case "/userprofile/admin":
      return ADMIN_KEY;
    case "/profile":
      return PROFILE_KEY;
    case "/paynow":
      return PAYNOW_KEY;
    case "/dashboard":
      return HOME_KEY;
    case "/order":
      return ORDER_KEY;
    case "/feedback":
      return FEEDBACK_KEY;
  }
};

function isStaging() {
  return [
    TROY_STAGE_HOSTNAME,
    TROY_PHOENIX_STAGE_HOSTNAME,
    VN_STAGE_HOSTNAME,
    ID_STAGE_HOSTNAME,
    GP_STAGE_HOSTNAME,
  ].includes(window.location.hostname);
}

function isLocal() {
  return TROY_LOCAL_HOSTNAME === window.location.hostname;
}

function isStorybook() {
  return (
    window.location.pathname.includes("storybook") ||
    window.location.hostname === "localhost"
  );
}

export const isMultiEntityUser = () => {
  const userPlatform = get(GET_USERPROFILE_FROM_LS(), [
    "user_profile",
    "platform",
  ]);
  return userPlatform === MULTI_ENTITY_PLATFORM;
};

export const isUnverifiedMerchantUser = () => {
  const userPlatform = get(GET_USERPROFILE_FROM_LS(), [
    "user_profile",
    "platform",
  ]);
  return userPlatform === UNVERIFIED_MERCHANT_PLATFORM;
};

export function GET_STACK() {
  const currency = localStorage.getItem("currency") || "";
  switch (currency.toLowerCase()) {
    case "idr":
      return ovo;
    case "vnd":
      return moca;
    default:
      return grabpay;
  }
}

export const hideInsightPage = () => {
  if (isUserPermissionSystemActive()) {
    return (
      !hasPermission({
        action: PERMISSION_ACTION.GET,
        module: getModuleNameByKey("insights"),
        legacyPermissionCheck: () => allowAccess(),
      }) ||
      isMasterMerchant() ||
      hasOvoOrMocaPaymentBusinessOnly()
    );
  } else {
    if (!hideDashboardPage()) {
      return false;
    }
    return (
      !allowAccess() || isMasterMerchant() || hasOvoOrMocaPaymentBusinessOnly()
    );
  }
};

export const hideDashboardPage = () => {
  const permissionSystemEnabledForDashboard =
    getConfigByKey("homepageEnabled") === true;
  if (
    permissionSystemEnabledForDashboard &&
    !hasPermission({
      action: PERMISSION_ACTION.GET,
      module: getModuleNameByKey("homepage"),
      legacyPermissionCheck: () => allowAccess(), // If the user is not onboarded to new permission system, this legacy check will be executed instead
    })
  ) {
    return true;
  }

  if (isMasterMerchant()) {
    return true;
  }
  const businessLineIds = getBusinessLineIdsFromLocalStorage();
  const stack = GET_STACK();

  if (
    hasOnlyOvoPaymentBusiness(stack, businessLineIds) ||
    hasOnlyMocaPaymentBusiness(stack, businessLineIds)
  ) {
    return true;
  }

  const paymentBusinessMerchantType = ["GF,GP", "GM,GP", "GF,GM,GP"];
  // hide dashboard for Mix and Match stores
  return (
    stack === grabpay &&
    haveAccessToFeature(mexHasMmOrder) &&
    !haveAccessToFeature(mexHasImOrder) &&
    !paymentBusinessMerchantType.includes(businessLineIds)
  );
};

const hasOnlyOvoPaymentBusiness = (stack, businessLineIds) => {
  if (stack.toLowerCase() !== ovo.toLowerCase()) {
    return false;
  }
  return businessLineIds.length === 1 && businessLineIds[0] === GP;
};

const hasOnlyMocaPaymentBusiness = (stack, businessLineIds) => {
  if (stack.toLowerCase() !== moca.toLowerCase()) {
    return false;
  }

  return businessLineIds.length === 1 && businessLineIds[0] === GP;
};

const hasOvoOrMocaPaymentBusinessOnly = () => {
  const stack = GET_STACK();
  const businessLineIds = getBusinessLineIdsFromLocalStorage();
  return (
    hasOnlyOvoPaymentBusiness(stack, businessLineIds) ||
    hasOnlyMocaPaymentBusiness(stack, businessLineIds)
  );
};

const getBusinessLineIdsFromLocalStorage = () => {
  // the localStorage data is coming from get-all-stores api
  // the value is set after user login success
  let result = localStorage.getItem(BUSINESS_LINE_IDS_LS);
  try {
    result = JSON.parse(result) || [];
  } catch (_) {
    result = [];
  }
  if (result && result.length > 0) {
    return result;
  }
  // if cannot get business lines from get-all-stores api
  // then get from user profile
  const userProfile = GET_USERPROFILE_FROM_LS() || {};
  result = get(userProfile, "business_line_ids") || [];
  return result;
};

export function isDraftUser() {
  const userProfile = GET_USERPROFILE_FROM_LS();
  if (!userProfile) {
    return false;
  }
  return userProfile.user_profile.profile_status === "DRAFT";
}

export function isAuthZRole() {
  return getUserRole() === ROLE_AUTHZ;
}

export function isSuperAdminRole() {
  return getUserRole() === ROLE_SUPER_ADMIN;
}

export function isCustomRole() {
  return isAuthZRole() || isSuperAdminRole();
}

export const isNotProd = () => isStaging() || isLocal() || isStorybook();

export const getDictLS = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}");
  } catch (error) {
    localStorage.removeItem(key); // remove corrupted data
    return {};
  }
};

export const setDictLS = (key, id, data) => {
  if (!data) return;

  const current = getDictLS(key);
  current[id] = data;
  localStorage.setItem(key, JSON.stringify(current));
};

export const delDictLS = (key, id) => {
  const current = getDictLS(key);
  if (isEmpty(current) && !current[id]) return;

  delete current[id];
  if (isEmpty(current)) localStorage.removeItem(key);
  else localStorage.setItem(key, JSON.stringify(current));
};

export const isObserver = () =>
  haveAccessToFeature(enableMexPortalObserverMode) &&
  get(GET_USERPROFILE_FROM_LS(), ["user_profile", "is_observer"], false);

export const isMarketingEnabledForObserver = () => {
  if (!isObserver()) return true;
  return haveAccessToFeature(enableMarketingForObserver);
};
